<ng-container>
    <form class="form-structures" data-tfa="form-structures" [formGroup]="parent">
        <ng-container [formArrayName]="name">
            @for (item of structuresFormControl.controls; track item; let i = $index) {
            <div class="individual-element">
                @if (filteredStructures$[i] | async; as structures) {
                <mat-form-field class="form-field">
                    <mat-label>{{ label() }}</mat-label>
                    <input
                        #input
                        type="text"
                        [name]="name"
                        [attr.data-tfa]="label()"
                        matInput
                        [formControl]="getControl(i)"
                        [matAutocomplete]="auto"
                    />
                    @if (input.value && parent.get(name)?.enabled) {
                    <mat-icon
                        matSuffix
                        class="icon-empty"
                        color="accent"
                        matTooltip="vider la valeur"
                        [attr.data-tfa]="'empty-input-icon_' + label()"
                        (click)="resetStructure(i)"
                        class="cursor-pointer"
                        >close</mat-icon
                    >
                    } @if (input.value && parent.get(name)?.enabled) {
                    <mat-icon
                        matSuffix
                        class="icon-remove"
                        color="accent"
                        matTooltip="supprimer la valeur"
                        [attr.data-tfa]="'remove-input-icon_' + label()"
                        (click)="structuresFormControl.removeAt(i); structuresFormControl.markAsDirty()"
                        class="cursor-pointer"
                        >delete</mat-icon
                    >
                    } @if (getControl(i)?.errors) {
                    <mat-error>
                        @if (getControl(i)?.errors?.vide) {
                        {{ getControl(i)?.errors?.vide }}
                        }
                    </mat-error>
                    }
                </mat-form-field>
                <mat-autocomplete
                    #auto="matAutocomplete"
                    data-tfa="autoComplete"
                    role="combobox"
                    aria-expanded="false"
                    aria-label="Sélection de structure"
                    aria-controls="idOptionStructures"
                    [panelWidth]="500"
                    [displayWith]="getFullValue(structures)"
                >
                    @for (n of structures; track n) {
                    <mat-option [value]="n.code" [attr.data-tfa]="'structures_option-' + n.code">
                        <span> {{ n.code }} : {{ n.libelle }} </span>
                    </mat-option>
                    }
                </mat-autocomplete>
                }
            </div>
            }
        </ng-container>
        <button
            data-tfa="ajouter-structure-button"
            color="accent"
            [disabled]="lastStructureIsEmpty || disabled()"
            (click)="addStructure()"
            matTooltip="ajouter une structure porteuse"
            mat-raised-button
        >
            Ajouter une structure
            <mat-icon data-tfa="icon-add">add</mat-icon>
        </button>
    </form>
</ng-container>
